export default "__VITE_ASSET__fdc9a453__"